import origmaps from '../config/maps.json';
import origcivs from '../config/civs.json';

export interface MapDetails {
    name: string;
    label: string;
    altNames?: string[];
    iconUrl: string;
    neutralSheepCount: number;
};

export interface CivDetails {
    name: string;
    label: string;
    draftFlagUrl: string;
    originalFlagUrl: string;
    aoe2cm: string;
};

export const maps: MapDetails[] = origmaps;
export const civs: CivDetails[] = origcivs.map(civ => ({name: civ[0] as string, ...(civ[1] as any)} as CivDetails)); // TODO: Change this once civs.json is refactored

// ----------------------

const fallbackMap = {
    "name": "Unknown",
    "label": "?",
    "iconUrl": "/maps/megarandom.png",
    "neutralSheepCount": 0
};

interface FindMapOptions {
    withFallback?: boolean;
}

export function findMap(map: string | null, options: FindMapOptions & { withFallback: true }): MapDetails;
export function findMap(map: string | null, options?: FindMapOptions): MapDetails | null;

export function findMap(map: string | null, options?: { withFallback?: boolean}) {
    const { withFallback } = options || {};
    if (!map) {
        return withFallback ? fallbackMap : null;
    }

    const mapDetails = maps.find(item => item.label === map || item.name === map || item?.altNames?.includes(map));

    if (mapDetails) {
        return mapDetails;
    } else if (withFallback) {
        return { ...fallbackMap, label: map };
    } else {
        return null;
    }
}

// ----------------------

const fallbackCiv = {
    "name": "Unknown",
    "label": "?",
    "draftFlag": "/draftFlags/Random.png",
    "originalFlag": "/civFlags/Random.png",
    "aoe2cm": ""
};

interface FindCivOptions {
    withFallback?: boolean;
}

export function findCiv(civ: string | null, options: FindCivOptions & { withFallback: true }): CivDetails;
export function findCiv(civ: string | null, options?: FindCivOptions): CivDetails | null;

export function findCiv(civ: string | null, options?: { withFallback?: boolean}) {
    const { withFallback } = options || {};

    if (!civ) {
        return withFallback ? fallbackCiv : null;
    }

    const civDetails = civs.find(item => item.label === civ || item.name === civ || item.aoe2cm === civ);

    if (civDetails) {
        return civDetails;
    } else if (withFallback) {
        return { ...fallbackCiv, label: civ };
    } else {
        return null;
    }
}
